import React, { useState, useEffect } from 'react';
import { useStyletron } from 'baseui';
import ScannerPage from './Scanner';

const ProtectedScanner = () => {
    const [css] = useStyletron();
    const [password, setPassword] = useState('');
    const [isAuthenticated, setIsAuthenticated] = useState(false);
    const [error, setError] = useState('');

    const correctPassword = process.env.REACT_APP_SCANNER_PASSWORD;

    // On mount, check localStorage for existing authentication state
    useEffect(() => {
        const saved = localStorage.getItem('isAuthenticated');
        if (saved === 'true') {
            setIsAuthenticated(true);
        }
    }, []);

    const handleSubmit = (e) => {
        e.preventDefault();
        if (password === correctPassword) {
            setIsAuthenticated(true);
            // Persist to localStorage
            localStorage.setItem('isAuthenticated', 'true');
            setError('');
        } else {
            setIsAuthenticated(false);
            localStorage.setItem('isAuthenticated', 'false');
            setError('Incorrect password. Please try again.');
        }
    };

    if (isAuthenticated) {
        return <ScannerPage />;
    }

    // Same styles from your ScannerPage
    const outerContainerStyle = css({
        minHeight: '100vh',
        background: 'linear-gradient(180deg, #d23c1b 0%, #BA5A31 48.55%, #E59F71 100%)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '2rem',
    });

    const containerStyle = css({
        width: '100%',
        maxWidth: '420px',
        padding: '1.5rem',
        background: '#fff',
        borderRadius: '8px',
        textAlign: 'center',
        color: '#333',
        boxShadow: '0 4px 8px rgba(0,0,0,0.1)',
    });

    const headerStyle = css({
        fontFamily: 'Impact, sans-serif',
        fontSize: '2.5rem',
        marginBottom: '1rem',
    });

    const inputStyle = {
        width: 'calc(100% - 20px)',
        padding: '0.75rem',
        fontSize: '1rem',
        borderRadius: '4px',
        border: '1px solid #ccc',
        marginBottom: '1rem',
    };

    const buttonStyle = {
        padding: '0.75rem 1.5rem',
        fontSize: '1rem',
        borderRadius: '4px',
        border: 'none',
        backgroundColor: '#d23c1b',
        color: '#fff',
        cursor: 'pointer',
    };

    return (
        <div className={outerContainerStyle}>
            <div className={containerStyle}>
                <h1 className={headerStyle}>Please Enter Password</h1>
                <form onSubmit={handleSubmit}>
                    <input
                        type="password"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        placeholder="Enter password"
                        style={inputStyle}
                    />
                    <div>
                        <button type="submit" style={buttonStyle}>
                            Submit
                        </button>
                    </div>
                </form>
                {error && <p style={{ color: 'red' }}>{error}</p>}
            </div>
        </div>
    );
};

export default ProtectedScanner;
